<template>
    <div class="field-wrapper flex flex-col" :class="{'field-wrapper--error': showError()}">
        <div class="flex flex-row">
            <div
                class="border-2 rounded-[4px] w-5 h-5 flex justify-center items-center text-xs transition-colors duration-200 ease-in-out cursor-pointer shrink-0 mr-2"
                :class="{
                    'border-green-accessible': localValue,
                    'border-red-default': showError()
                }"
                @click="updateInput(!localValue)"
                @focus="onFocus"
            >
                <span class="sr-only">Include local phone number</span>
                <Transition name="check-mark">
                    <span v-if="localValue" class="icon-checkmark text-green-accessible"></span>
                </Transition>
            </div>
            <input
                type="checkbox"
                name=""
                ref="input"
                class="sr-only"
                :id="inputId"
                :value="localValue"
                :checked="localValue"
                :required="required"
                @change="updateInput(!localValue)"
                :aria-labelledby="labelledByIds"
            />
            <label class="text-2xs field-label-v2" :for="inputId" :id="`label-${inputId}`">
                <slot name="label"></slot>
                <span v-if="!$slots.label">{{ fieldLabel }}<span v-if="required" class="">&nbsp;*</span></span>
            </label>
        </div>
        <div class="text-gray-2 text-xs" v-if="!showError() && $slots.helper" :for="inputId" :id="`helper-text-${inputId}`">
            <slot name="helper"></slot>
        </div>
        <div class="text-red-default text-xs" v-if="showError() && $slots.error" aria-live="polite">
            <slot name="error"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isFocused: false,
            localValue: false,
            dirty: false,
        };
    },
    mounted() {
    },
    props: {
        fieldLabel: String,
        fieldType: String,
        required: Boolean,
        valid: Boolean,
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onFocus() {
            this.isFocused = true;
        },
        updateInput(value) {
            if (this.disabled && this.required) {
                this.dirty = true;
                return;
            }
            if (this.localValue) {
                this.dirty = true;
            }
            this.localValue = value;
            this.$refs.input.value = this.localValue;
            this.$emit('update:modelValue', this.localValue);
        },
        showError() {
            if (!this.localValue && !this.dirty) {
                return false;
            }
            if (!this.dirty) {
                return false;
            }
            return !this.valid;
        }
    },
    created() {
        this.localValue = this.value || false;
    },
    computed: {
        labelledByIds() {
            let ids = `label-${this.inputId}`;
            if (this.$slots.helper) {
                ids += ` helper-text-${this.inputId}`
            }
            return ids;
        },
        inputId() {
            const uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
            return uuid;
        }
    },
    watch: {
        localValue(newVal, oldVal) {
            this.localValue = newVal;
        },
        value(newVal, oldVal) {
            this.localValue = newVal;
        }
    }
};
</script>

<style lang="postcss" scoped>
</style>
